<template>
 <el-form label-width="" ref="ruleForm2" >
  <el-col :span="20">
  <el-col>
     <el-form-item  prop="fileList">
        <el-upload
              ref="upload"
              name="file"
              action="bb"
              :before-remove="handleRemove"
              :on-remove="handleOnRemove"
              :on-change="handleChange"
              :auto-upload="false"
              :file-list="file.fileList">
            <el-button icon="el-icon-upload2">上传文件</el-button>
        </el-upload>
     </el-form-item>
  </el-col>
    <el-col>
      <div v-if="file.fileList.length === 0" class="tip">支持扩展名.rar .zip .doc .docx .pdf .jpg.....</div>
    </el-col>
  </el-col>
 </el-form>
</template>
<script>
import { previewFileUpload } from '@/api/fileServer'
import eventBus from '@/assets/js/eventBus'
export default {
  props: {
    file: {
      type: Object
    },
    fileType: {
      type: Number
    }
  },
  data () {
    // const fileListValidate = (rule, value, callback) => {
    //   if (this.file.fileList.length === 0) {
    //     callback(new Error('请上传文件'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      // form: {
      //   fileList: this.file.fileList ? Object.assign([], this.file.fileList) : []
      // },
      // rules: {
      //   fileList: [
      //     { validator: fileListValidate, trigger: 'change' }
      //   ]
      // },
      customizeCategoryName: ''
    }
  },
  created () {
    // eventBus.$on('validateProductFileList', this.validateFileList)// 验证表单
    eventBus.$on('resetFields', this.resetFields)// 重置表单
  },
  methods: {
    resetFields () {
      if (this.$refs.ruleForm2) {
        this.$refs.ruleForm2.resetFields()
      }
    },
    validateFileList () {
      this.$refs.ruleForm2 && this.$refs.ruleForm2.validate(valid => {
        if (!valid) {
          this.file.validate = false
        }
      })
    },
    handleChange (file, fileList) {
      eventBus.$emit('addDelImg', [this.file.fileToken])
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('dir', 'product/file/')
      if (fileList.length > 1) {
        this.file.fileList.splice(0, 1)
      }
      debugger
      previewFileUpload(formData).then(res => {
        if (res.status === 200) {
          debugger
          const fileItem = {
            fileUrl: res.data.data.fileUrl,
            fileToken: res.data.data.pathKey,
            businessType: this.fileType,
            fileName: file.name
          }
          this.file.fileInfos.push(fileItem)
          this.file.fileList.splice(0, this.file.fileList.length, ...fileList)
          // this.file.fileName = file.name
          // this.file.fileToken = res.data.pathKey
          // this.file.fileType = this.fileType
          // this.$refs.ruleForm2.clearValidate()// 清除表单校验信息
        } else {
          this.file.fileList.splice(0, 1)
        }
      }, res => {
        this.file.fileList.splice(0, 1)// 上传出错清空
      })
    },
    handleOnRemove (file, fileList) {
      this.file.fileList = fileList
    },
    handleRemove (file, fileList) {
      // eventBus.$emit('addDelImg', [this.file.fileToken])
      this.file.fileList = fileList
    }
  }
}
</script>
<style lang='less' scoped>
.tip{
  color:#b2b3b7;
  margin-top: 10px;
}
.avatar-uploader-icon {
     font-size: 14px;
    color:white;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color:#409EFF;
    border-radius: 25px;
    cursor: pointer;
  }
  .el-button{
    margin-left: 10px;
  }
  .el-icon-delete-solid{
    font-size: 20px;
    cursor: pointer;
  }
</style>
